import React from 'react';
import '../template-file-css/document-file-template.css';


export const EYPC_DmaIihSra = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='EYPC_DmaIihSra' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><center><h3><b>SERVICE AUTHORIZATION FORM
                    <br /> CMHRS CONTINUED STAY Service Authorization Request Form</b></h3></center></p>

                <p className='w-750'><center><h4><b>MEMBER INFORMATION</b></h4></center></p><br />

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member First Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Last Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMemberFirstName' name='txtMemberFirstName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberLastName' name='txtMemberLastName' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medicaid #:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Member Date of Birth:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Gender:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtMemberDateOfBirth' name='txtMemberDateOfBirth' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male&nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female&nbsp;
                            <input type='radio' id='rbGender_Other' name='rbGender' className='add-only' value='Other' /> Other</td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Plan ID #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Street Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMemberPlanId' name='txtMemberPlanId' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberStreetAddress' name='txtMemberStreetAddress' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip:</span></td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCity' name='txtCity' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtState' name='txtState' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtZip' name='txtZip' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Guardian:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Guardian Contact Information:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtParentGuardian' name='txtParentGuardian' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtParentGuardianContactInformation' name='txtParentGuardianContactInformation' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Service Requested:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbServiceRequested_1' name='rbServiceRequested' className='add-only' value='1' /> IIH (H2012)&nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbServiceRequested_2' name='rbServiceRequested' className='add-only' value='2' /> MHSS (H0046)&nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbServiceRequested_3' name='rbServiceRequested' className='add-only' value='3' /> PSR (H2017)&nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbServiceRequested_4' name='rbServiceRequested' className='add-only' value='4' /> TDT (H2016)</td>
                    </tr>
                </table>

                <p className='w-750'><center><h4><b>PROVIDER INFORMATION</b></h4></center></p><br />

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Organization Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Group NPI #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOrganizationName' name='txtOrganizationName' placeholder='Empowering Youth for Positive Change' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtGroupNpi' name='txtGroupNpi' defaultValue={1538446679} className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Tax ID #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Phone:</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderTax' name='txtProviderTax' defaultValue={473114954} className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtProviderPhone' name='txtProviderPhone' defaultValue={8047891314} className='add-only' /></td>

                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider E-Mail:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider Address:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider Fax:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtProviderEmail' name='txtProviderEmail' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtProviderAddress' name='txtProviderAddress' placeholder='101 Cowardin Avenue' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtProviderFax' name='txtProviderFax' placeholder='8044823767' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip:</span></td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCity_1' name='txtCity_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtState_1' name='txtState_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtZip_1' name='txtZip_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Clinical Contact Name & Credentials*:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Clinical Contact Phone:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtClinicalContactName' name='txtClinicalContactName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtClinicalContactPhone' name='txtClinicalContactPhone' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>* This is the individual to whom the MCO can reach out
                    to answer additional clinical questions</b></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If requesting TDT services, check one of the following:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbRequestingServicesCheckFollowing_1' name='rbRequestingServicesCheckFollowing' className='add-only' value='1' />  H2016 - (school day)</td>
                        <td className='w-250'>
                            <input type='radio' id='rbRequestingServicesCheckFollowing_2' name='rbRequestingServicesCheckFollowing' className='add-only' value='2' />  H2016 - UG (after-school)</td>
                        <td className='w-250'>
                            <input type='radio' id='rbRequestingServicesCheckFollowing_3' name='rbRequestingServicesCheckFollowing' className='add-only' value='3' /> H2016 - U7 (summer)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Provide the name of the school and/or setting where these services are being provided:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtProvideTheNameSchoolSetting' name='txtProvideTheNameSchoolSetting' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Initial Admission Date to Services:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Average # of units provided per week:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtInitialAdmissionDateServices' name='txtInitialAdmissionDateServices' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtAverageUnitsProvidedPerWeek' name='txtAverageUnitsProvidedPerWeek' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Request for approval of services:</span>
                    From&nbsp;
                    <input type='date' id='txtRequestForApprovalServices_1' name='txtRequestForApprovalServices_1' className='add-only w-150 custom-add-only' /> (date), To&nbsp;
                    &nbsp;<input type='date' id='txtRequestForApprovalServices_2' name='txtRequestForApprovalServices_2' className='add-only w-150 custom-add-only' /> (date), for a total of&nbsp;
                    &nbsp;<input type='text' id='txtRequestForApprovalServices_3' name='txtRequestForApprovalServices_3' className='add-only w-150 custom-add-only' /> units of service.&nbsp;
                    Plan to provide
                    &nbsp;<input type='text' id='txtRequestForApprovalServices_4' name='txtRequestForApprovalServices_4' className='add-only w-150 custom-add-only' /> hours of service per week.
                    <br />

                    <span className='eleHeader'>Primary ICD-10 Diagnosis</span>
                    <input type='text' id='txtPrimaryDiagnosis' name='txtPrimaryDiagnosis' className='add-only' /> <br />

                    <span className='eleHeader'>Secondary Diagnosis(es)</span>
                    <input type='text' id='txtSecondaryDiagnosis' name='txtSecondaryDiagnosis' className='add-only' /> <br /><br />
                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name of Medication</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Dosage </span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfMedication_1' name='txtNameOfMedication_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtDosage_1' name='txtDosage_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfMedication_2' name='txtNameOfMedication_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtDosage_2' name='txtDosage_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfMedication_3' name='txtNameOfMedication_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtDosage_3' name='txtDosage_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfMedication_4' name='txtNameOfMedication_4' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtDosage_4' name='txtDosage_4' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>If additional medications are prescribed, include listing of medications, dosage, and frequency in the Notes section.</b> <br /><br />

                    <center><h4><b>SECTION I: CARE COORDINATION
                    </b></h4></center>
                    <b>Please indicate other current medical/behavioral services and additional community interventions/supports
                        received:</b></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name of service/treatment </span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider/Contact Information</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfServiceTreatement_1' name='txtNameOfServiceTreatement_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtProviderContactInformation_1' name='txtProviderContactInformation_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_5' name='txtFrequency_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfServiceTreatement_2' name='txtNameOfServiceTreatement_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtProviderContactInformation_2' name='txtProviderContactInformation_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_6' name='txtFrequency_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfServiceTreatement_3' name='txtNameOfServiceTreatement_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtProviderContactInformation_3' name='txtProviderContactInformation_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_7' name='txtFrequency_7' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Describe Care Coordination activities with other services and providers since the last authorization:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtDescribeCareCoordinationActivities' name='txtDescribeCareCoordinationActivities' className='add-only'></textarea></td>
                    </tr>

                </table>

                <p className='w-750'><center><h4><b>SECTION II: TREATMENT PROGRESS</b></h4></center>
                    <b>Treatment Goals/Progress:</b> <br />
                <ul>
                    <li>Describe person-centered, recovery-oriented, trauma-informed mental health treatment goals as they relate to
                        requested treatment. These should be written in the words of the individual or in a manner that is understood by the
                        individual seeking treatment, include their individual strengths/barriers to/and gaps in service. If individual has
                        identified a history of trauma, please include trauma-informed care interventions in the treatment plan</li>
                    <li>Services are intended to include goal directed training/interventions that will enable individuals to learn the skills
                        necessary to achieve or maintain stability in the least restrictive environment. Providers should demonstrate efforts
                        to assist the individual in progressing toward goals to achieve their maximum potential.</li>
                    <li>Please demonstrate that the individual is benefiting from the service as evidenced by objective progress toward
                        goals or modifications and updates that are being made to the treatment plan to address areas with lack of
                        progress. Include any appointments and medication adherence issues and plan to address this if applicable.</li>
                </ul>
                </p>

                <p className='w-750'><span className='eleHeader'><b>Resources and Strengths: </b>Document individual's strengths, preferences, extracurricular/community/social activities
                    and people the individual identifies as supports.</span>
                    <textarea id='txtResourcesAndStrengths' name='txtResourcesAndStrengths' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Please describe any barriers to treatment:</span>
                    <textarea id='txtPleaseDescribeAnyBarriersToTreatment' name='txtPleaseDescribeAnyBarriersToTreatment' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'><b>Goal/Objective</b> (Please provide objective measures to demonstrate evidence of progress. Measurable objectives
                    should have meaningful tracking values; avoid percentages unless able to track and measure percent completion i.e. if
                    80%, state 8 of 10 as a more trackable value):
                </span>
                    <textarea id='txtGoalObjectivePleaseProvideObjective' name='txtGoalObjectivePleaseProvideObjective' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>How many days per week will be spent addressing this goal on average?</span>
                    <input type='text' id='txtHowManyDaysPerWeekWillSpent' name='txtHowManyDaysPerWeekWillSpent' className='add-only' /></p>

                <p className='w-750'><span className='eleHeader'>What specific training and interventions will be provided to address this goal?</span>
                    <textarea id='txtWhatSpecificTrainingAndInterventionsWill' name='txtWhatSpecificTrainingAndInterventionsWill' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>How will you measure progress on the interventions provided?</span>
                    <textarea id='txtHowWillYouMesureProgressOnTheInterventions' name='txtHowWillYouMesureProgressOnTheInterventions' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Progress toward Goal/Objective:</span>
                    <textarea id='txtProgressTowardGoalObjective' name='txtProgressTowardGoalObjective' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Lack of Progress and Changes made to ISP to address this:</span>
                    <textarea id='txtLackOfProgressAndChangesMadeAddress' name='txtLackOfProgressAndChangesMadeAddress' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'><b>Goal/Objective</b>(Please provide objective measures to demonstrate evidence of progress. Measurable objectives
                    should have meaningful tracking values; avoid percentages unless able to track and measure percent completion i.e. if
                    80%, state 8 of 10 as a more trackable value):</span>
                    <textarea id='txtGoalObjectivePleaseProvide' name='txtGoalObjectivePleaseProvide' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>How many days per week will be spent addressing this goal on average?</span>
                    <input type='text' id='txtHowManyDaysPerWeekWillSpentAverage' name='txtHowManyDaysPerWeekWillSpentAverage' className='add-only' /></p>

                <p className='w-750'><span className='eleHeader'>What specific training and interventions will be provided to address this goal?</span>
                    <textarea id='txtWhatSpecificTrainingAndInterventionsWillBe' name='txtWhatSpecificTrainingAndInterventionsWillBe' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>How will you measure progress on the interventions provided?</span>
                    <textarea id='txtHowYouMeasureInterventionsProvided' name='txtHowYouMeasureInterventionsProvided' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Progress toward Goal/Objective:</span>
                    <textarea id='txtProgressGoalObjective' name='txtProgressGoalObjective' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Lack of Progress and Changes made to ISP to address this:</span>
                    <textarea id='txtLackProgressChangesAddress' name='txtLackProgressChangesAddress' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Goal/Objective (Please provide objective measures to demonstrate evidence of progress. Measurable objectives
                    should have meaningful tracking values; avoid percentages unless able to track and measure percent completion i.e. if
                    80%, state 8 of 10 as a more trackable value):</span>
                    <textarea id='txtGoalObjectiveObjectiveMeasuresTo' name='txtGoalObjectiveObjectiveMeasuresTo' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>How many days per week will be spent addressing this goal on average?</span>
                    <input type='text' id='txtHowDaysPerWeekAddressingOn' name='txtHowDaysPerWeekAddressingOn' className='add-only' /></p>

                <p className='w-750'><span className='eleHeader'>What specific training and interventions will be provided to address this goal?</span>
                    <textarea id='txtSpecificInterventionsWillGoal' name='txtSpecificInterventionsWillGoal' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>How will you measure progress on the interventions provided?</span>
                    <textarea id='txtWillMeasureProgressInterventionsProvided' name='txtWillMeasureProgressInterventionsProvided' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Progress toward Goal/Objective:</span>
                    <textarea id='txtProgressObjective' name='txtProgressObjective' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Lack of Progress and Changes made to ISP to address this:</span>
                    <textarea id='txtLackProgressChangeMadeThis' name='txtLackProgressChangeMadeThis' className='add-only'></textarea></p>

                <p className='w-750'><center><h4><b>For IIH and TDT</b></h4></center>
                    <span className='eleHeader'>Overview of family involvement during service period with regards to the individual's ISP to include who has
                        been involved and progress made/continuing needs of family goals/training:
                    </span>
                    <textarea id='txtOverviewFamilyInvolvementDuringService' name='txtOverviewFamilyInvolvementDuringService' className='add-only'></textarea></p>

                <p className='w-750'><center><h4><b>For MHSS members under 21 years of age</b></h4></center>
                    <span className='eleHeader'>If member is not currently living in an independent living situation and has been actively transitioning into
                        independent living at the initiation of services, please describe progress toward this transition within 6 months
                        of receiving services:
                    </span>
                    <textarea id='txtIfMemberIsNotCurrentlyLivingIndependent' name='txtIfMemberIsNotCurrentlyLivingIndependent' className='add-only'></textarea></p>

                <p className='w-750'><center><h4><b>SECTION III: DISCHARGE PLANNING</b></h4></center>
                    <b>DISCHARGE PLAN</b> (Identify lower levels of care, natural supports, warm-hand off, care coordination needs)</p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Step Down Service/Supports</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Identified Provider/Supports</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Plan to assist in transition</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtStepDownServiceSupports_1' name='txtStepDownServiceSupports_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtIdentifiedProvidedSupports_1' name='txtIdentifiedProvidedSupports_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtPlanAssistTransition_1' name='txtPlanAssistTransition_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtStepDownServiceSupports_2' name='txtStepDownServiceSupports_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtIdentifiedProvidedSupports_2' name='txtIdentifiedProvidedSupports_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtPlanAssistTransition_2' name='txtPlanAssistTransition_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtStepDownServiceSupports_3' name='txtStepDownServiceSupports_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtIdentifiedProvidedSupports_3' name='txtIdentifiedProvidedSupports_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtPlanAssistTransition_3' name='txtPlanAssistTransition_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>Estimated Date of Discharge:
                            <input type='date' id='txtEstimatedDateDischarge' name='txtEstimatedDateDischarge' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recommended level of care at discharge:
                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtRecomendedLevelCareDischarge' name='txtRecomendedLevelCareDischarge' className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            The appropriate assessment or addendum has been completed by an LMHP, LMHP-R, LMHP-S,
                            or LMHP-RP and the individual's psychiatric history information reviewed. By my signature
                            (below) I am attesting that the individual meets the medical necessity criteria for the identified
                            service. The date of the most recent assessment or applicable addendum for this service was
                            completed on
                            <input type='date' id='txtTheAppropriateAssessmentAddendum' name='txtTheAppropriateAssessmentAddendum' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'>Signature (actual or electronic) of LMHP (Or R/S/RP)</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Printed Name of LMHP (Or R/S/RP):</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtPrintedName' name='txtPrintedName' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Credentials:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCredentials' name='txtCredentials' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>If any additional CMHRS services were recommended by the assessment or addendum referenced above, please identify
                    the services here:</span>
                    <textarea id='txtIfAnyAdditionalServicesWereRecommended' name='txtIfAnyAdditionalServicesWereRecommended' className='add-only'></textarea>  <br />
                    <br />

                    <center><h4><b>NOTES SECTION</b></h4></center>
                    <textarea id='txtNotesSection' name='txtNotesSection' className='add-only'></textarea></p>
























            </div >
        </form >

    )
}











